import React, { useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap'


const Age = () => {

    const [show, toggleShow] = useState(true);

    const [selectedOption, setSelectedOption] = useState(''); // Initialize with an empty string or 'yes'/'no'

    const handleOptionChange = (event) => {
      setSelectedOption(event.target.value);
    };

  return (
    <div>
      <Container>
        <Row>
            <Col md={12}>
            {show && <Card className=' shadow-sm px-2' border='0'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6 className='text-secondary mt-3'>Age</h6>
                        <button onClick={() => toggleShow(!show)} className='text-secondary bg-white border-0'>x</button>
                    </div>
                                <label htmlFor="yesOption" className='text-secondary mb-2 ' style={{fontSize:'14px'}}>
                                <input
                                    type="radio"
                                    id="yesOption"
                                    value="yes"
                                    checked={selectedOption === 'yes'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    18-24
                                   
                                </label>


                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption"
                                    value="no"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    25-34
                                </label>

                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption1"
                                    value="other"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    35-44 
                                </label>

                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption1"
                                    value="other"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    45-54 
                                </label>
                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                <input
                                type="radio"
                                id="noOption1"
                                value="other"
                                checked={selectedOption === 'no'}
                                onChange={handleOptionChange}
                                className='me-3'
                                />
                                55-64 
                            </label>
                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption1"
                                    value="other"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    65+ 
                                </label>
                            
                </Card>}
            </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Age
